export default __webpack_public_path__ + "static/media/skyPondSlide1.45f83b8a.jpg";